<template>
  <div class="zone" v-loading="exporting" :element-loading-text="loadingText">
    <functionBox  :titleData="{permission_flag:'SparePart',nowID:1}"  :notes="notes ? notes : ''" :hideSearchBtn = true
                  @searchBtn="searchBtn" @addCheck="editCheck('0')"   :searhLoading="loading">
      <template>
        <li>
          <el-input placeholder="请输入关键字" v-model="searchParams.keywords" clearable size="small"></el-input>
        </li>

        <li>
          <el-date-picker
              size="small"
              v-model="search_time"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="marginLeft:10px"
              class="Calendar"
              @clear="clearSearchTime"
          />
        </li>
        <li>
          <el-button type="primary" size="mini" @click="searchBtn">搜索</el-button>
        </li>
        <div  class="right" style="margin-top: 10px;text-align: right;">

          <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddQuestBank"   style="text-align: right; background: #347CAF;border:#347CAF">新增题库</el-button>
        </div>
      </template>
    </functionBox>
    <div class="sheet"  v-loading="loading" :element-loading-text="loadingText">
      <el-table :data="tableData" stripe  :height="tableSize== 'big' ? '960' : tableSize== 'middle' ?'630' : '430'" >
        <el-table-column type="index" width="55" label="#"> </el-table-column>
        <el-table-column prop="title" label="题库名称" width="220" align="center"></el-table-column>
        <el-table-column prop="question_total" label="总题量" width="120" align="center"></el-table-column>
        <el-table-column prop="question_types.2001" label="单选题题量"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="question_types.2002" label="多选题题量"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="question_types.2003" label="是非题题量"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="question_types.2004" label="填空题题量"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="question_types.2005" label="问答题题量"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="" label="操作" :width="tableSize== 'big' ? '450' : tableSize== 'middle' ?'400' : '380'" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button size="mini"  @click="handleJump(row,'1')"  class="train-check-btn">查看</el-button>
            <el-button size="mini"  @click="handleJump(row,'2')"   class="train-edit-btn">编辑</el-button>
            <el-button size="mini" @click="handleJump(row,'3')"  class="train-update-btn">更新题库信息</el-button>
            <el-button size="mini"  @click="handleDelete(row)"  class="train-delete-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="el_pagination_style">
        <el-pagination
            :hide-on-single-page="total <= 0"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="size"
            :current-page.sync="page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>
      <el-dialog
          title="新增题库信息"
          :visible.sync="addQuestBankDialog"
          width="80%"
          :before-close="handleClose">
        <add-quest-bank-dialog v-if="addQuestBankDialog"></add-quest-bank-dialog>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addQuestBankDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirmExport()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TJDetailTitle from '@/components/TJDetailTitle.vue'
import timePicker from '@/components/timePicker.vue'
// import { hospitals_list,organization_list } from '@/api/search.js'
import FunctionBox from '@/views/Statistics/components/functionBox.vue'
import PlatSelect from "@/components/PlatSelect.vue";
import {getInventoryList, deleteCheck, exportCheck, snyc_instrument} from "@/api/assetCheck";
import checkCommon from "@/views/AssetCheck/mixin/checkCommon";
import {addMenu, getAssetMgtBtn} from "@/router/menuMain";
import {getToken} from "@/utils/auth";
import addQuestBankDialog from "@/views/cloudTraining/question/addQuestBank.vue";
import {deleteQuestionBank, getRepositoryList} from "@/api/training";

export default {
  components: {PlatSelect, TJDetailTitle, timePicker, FunctionBox,addQuestBankDialog},
  name: 'questionBankList',  // 资产管理列表
  mixins: [checkCommon],
  data() {
    return {
      addQuestBankDialog:false,
      userRoleId: JSON.parse(localStorage.getItem('userInfo')).org_post,
      confirmDialog: false,

      tableSize: '',
      user_id: '',
      page: 1,
      size: 10,
      total: 0,
      notes: '',
      exporting: false, //加载动画
      loading: false, //加载动画
      tableData: [],
      search_time: [],
      selectedNotes: [],
      selectedList: [],
      selectedRows: [],
      is_export: false,
      tableHeight: 0,
      searchType: '0',
      message: '',
      searchParams:{
        keywords: '',
        start_time: '',
        end_time: '',
      },
      pageParams:{
        page: 1,
        size:10,
      },
      loadingText: '数据加载中，请稍后'
    }
  },
  created() {
    this.getTableHeight()

    this.getList()
    this.user_id = JSON.parse(localStorage.getItem("userInfo")).user_id
    if(window.innerWidth<1550){
      this.tableSize = 'small'
    }else if(window.innerWidth < 2400 && window.innerWidth > 1550){
      this.tableSize = 'middle'
    }else{
      this.tableSize = 'big'
    }
  },
  methods: {
    getTableHeight(){
      var viewportHeight = window.innerHeight;
      var viewportWidth =  window.innerWidth
      // var element = document.getElementById('pagination');
      if(viewportWidth > 2400){
        this.tableHeight = viewportHeight - 500
      }else if(viewportWidth < 2400 &&  viewportWidth > 1550){
        this.tableHeight = viewportHeight - 400
      }else{
        this.tableHeight = viewportHeight - 600
      }
    },
    getList(){
      this.loading = true
      this.loadingText = '数据加载中，请稍后'
      if(this.searchType != '1' ){   //searchType = '0' 从详情返回的时候，需要获取缓存的搜索条件
        if(sessionStorage.getItem('qbPageParams')){
          this.pageParams = JSON.parse(sessionStorage.getItem('qbPageParams')).pageParams
          this.size = this.pageParams.size || 10
          this.page=this.pageParams.page || 1
        }
        if(JSON.parse(sessionStorage.getItem('qbSearchParams'))){
          this.searchParams = {...JSON.parse(sessionStorage.getItem('qbSearchParams')).searchParams};
          if(this.searchParams && this.searchParams.start_time && this.searchParams.end_time){
            this.search_time = [this.searchParams.start_time,this.searchParams.end_time]
          }else{
            this.search_time = []
          }
        }
      }
      if(this.search_time && this.search_time.length>0){
        this.searchParams.end_time = this.search_time[1]
        this.searchParams.start_time = this.search_time[0]
      }else{
        this.searchParams.end_time = ''
        this.searchParams.start_time = ''
      }
      let params = {
        ...this.searchParams,
        page:  this.pageParams.page,
        size: this.pageParams.size
      }
      getRepositoryList(params).then(res=>{
        this.total = res.data.count
        this.tableData = res.data.data
        this.loading = false
      }).catch(err =>{
        this.loading = false
        if( err.status === 'error' && this.searchParams.page >1 ){
          this.searchParams.page--
          this.getList()
        }
      })
    },

    searchBtn() {  // 搜索
      this.page = 1
      if(this.search_time){
        this.searchParams.start_time = this.search_time[0]
        this.searchParams.end_time = this.search_time[1]
      }else{
        this.searchParams.start_time = ''
        this.searchParams.end_time = ''
      }
      this.searchType = '1'
      this.getList();
      sessionStorage.setItem('qbSearchParams', JSON.stringify({ searchParams:this.searchParams }));
      sessionStorage.setItem('qbPageParams', JSON.stringify({ pageParams:{page: 1,size:10} }));
    },
    handleCurrentChange(val) { // 翻页
      this.page = val
      this.pageParams.size = this.size
      this.pageParams.page = this.page
      sessionStorage.setItem('qbSearchParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1')
    },

    clearSearchTime(){
      this.searchParams.start_time = ''
      this.searchParams.end_time = ''
      this.search_time = []
      this.getList();
    },
    handleDelete(row){
      const h = this.$createElement
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', `确认删除这条数据？`),]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuestionBank({repository_id:row.repository_id}).then(res=>{
          if(res.code == 200){
            this.$message.success('删除成功！')
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认',
        })
      })
    },
    handleSizeChange(val){
      this.pageParams.size = val
      this.pageParams.page = this.page
      sessionStorage.setItem('qbSearchParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1');
    },

    handleJump(row,type) {
      let typeTemp = ''
      if(type === '1'){
        typeTemp = 'check'
      }else if(type === '2'){
        typeTemp = 'edit'
      }else if(type === '3'){
        typeTemp = 'update'
      }
      this.$router.push({ path: '/cloudTraining/question/addQuestBank',query: {id: row.repository_id,type: typeTemp } })
    },

    handleClose(){
      this.confirmDialog = false
    },

    handleConfirmExport(){  //导出弹窗确认
      this.confirmDialog = false
      this.getList()
      // if(this.selectedNotes.length > 0){
      this.exportCheck(null, null)

      // }else{
      //   this.$message.error('请选择需要导出的盘点单！')
      // }
    },
    handleAddQuestBank(){
      this.$router.push({ path: '/cloudTraining/question/addQuestBank',query:{type: 'quest' }})
    }

  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/asset';
::v-deep .el-table th:first-child.el-table__cell>.cell{
  padding-left:14px!important;
}
::v-deep .el-pagination__sizes{
  width: 80px;
  vertical-align: top;
}
::v-deep .el-pagination__sizes .el-select{
  vertical-align: top;
}
::v-deep .el-pagination__sizes input{
  width: 80px;
  height: 1.8rem;
  border: 1px solid #999999;
}
::v-deep .el-pagination .el-input__suffix{
  right: 22px;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 0.75rem!important;
}
.export{
  p{
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
}
.wait{
  background: #9A9A9A;
  color:#fff;
  font-size: px(14);
}
.checking{
  background: #567722;
  color:#fff;
  font-size: px(14);

}
.completed{
  background: #4095E5;
  color:#fff;
  font-size: px(14);
}
.sync-btn{
  color:#fff;
  background: #CBA43F;
}
.train-edit-btn{
  background: #fff;
  border:1px solid #F2995F;
  color: #F2995F;
}
.train-update-btn{
  background: #fff;
  border:1px solid #567722;
  color: #567722;
}
.train-check-btn{
  background: #fff;
  border:1px solid #4095E5;
  color: #4095E5;
}
.train-delete-btn{
  background: #fff;
  border:1px solid #E34D59;
  color: #E34D59;
}
::v-deep .el-dialog__footer{
  text-align: center;
}
::v-deep .el-dialog__header{
  margin: 0 20px;
  border-bottom: 1px solid #eee;
}
</style>
